import { defineStore } from 'pinia';
import { BRAND_STORAGE_KEYS } from '@sys/shared/constants';
import { cache } from '@sys/shared/utils';

export const useUserStore = defineStore('user', {
  persist: {
    pick: ['userInfo', 'permissions', 'roles', 'menuRoutes', 'routePages', 'permissionTree'],
  },
  state: () => ({
    token: cache.get(BRAND_STORAGE_KEYS.TOKEN, ''),
    userInfo: null,
    permissions: [],
    roles: [],
    menuRoutes: [],
    routePages: [],
    permissionTree: [],
  }),

  getters: {
    isLoggedIn: state => !!state.token,
    brandNo: state => state.userInfo?.brand_no || '',
    hasPermission: state => perm => {
      if (!perm) return true;
      if (!state.permissions.length) return true;
      return state.permissions.includes(perm);
    },
  },

  actions: {
    setToken(token) {
      this.token = token;
      cache.set(BRAND_STORAGE_KEYS.TOKEN, token);
    },

    applyAuthContext(data) {
      if (data.user) this.userInfo = data.user;
      if (data.permissions) this.permissions = data.permissions;
      if (data.roles) this.roles = data.roles;
      if (data.menu_routes) this.menuRoutes = data.menu_routes;
      if (data.route_pages) this.routePages = data.route_pages;
      if (data.permission_tree) this.permissionTree = data.permission_tree;
    },

    logout() {
      this.token = '';
      this.userInfo = null;
      this.permissions = [];
      this.roles = [];
      this.menuRoutes = [];
      this.routePages = [];
      this.permissionTree = [];
      cache.remove(BRAND_STORAGE_KEYS.TOKEN);
    },
  },
});
